export function unwrapAgentList(response) {
  if (Array.isArray(response?.data?.data)) return response.data.data
  if (Array.isArray(response?.data)) return response.data
  if (Array.isArray(response)) return response
  return []
}

export function mapAgentOption(agent) {
  return {
    id: agent.id,
    name: agent.name,
    lastname: agent.lastname,
    pay_to_visit: Number(agent.pay_to_visit) || 0,
  }
}

function settleSelection(state) {
  const selectedId = Number(state.agentUserId)
  if (!selectedId) {
    return { ...state, agentUserId: null }
  }
  const stillListed = state.agentOptions.some(
    agent => Number(agent.id) === selectedId
  )
  return {
    ...state,
    agentUserId: stillListed ? state.agentUserId : null,
  }
}

export function agentOptionsAfterAll(state, response) {
  const allAgentOptions = unwrapAgentList(response).map(mapAgentOption)
  return settleSelection({
    ...state,
    allAgentOptions,
    agentOptions: state.adminUserId ? state.agentOptions : allAgentOptions,
  })
}

export function agentOptionsAfterAllFailure(state) {
  return settleSelection({
    ...state,
    allAgentOptions: [],
    agentOptions: state.adminUserId ? state.agentOptions : [],
  })
}

export function agentOptionsAfterAdmin(state, adminId, response) {
  if (!adminId) {
    return settleSelection({
      ...state,
      adminUserId: null,
      agentOptions: state.allAgentOptions,
    })
  }
  return settleSelection({
    ...state,
    adminUserId: adminId,
    agentOptions: unwrapAgentList(response).map(mapAgentOption),
  })
}

export function agentOptionsAfterAdminFailure(state, adminId) {
  return settleSelection({
    ...state,
    adminUserId: adminId,
    agentOptions: [],
  })
}
